import Vue from 'vue';
import Vuex from 'vuex';
import actions from './themes-actions';
import getters from './themes-getters';
import mutations from './themes-mutations';
import state from './themes-state';

Vue.use(Vuex);
export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
